import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { RadioButton } from 'primereact/radiobutton';
import { Toast } from 'primereact/toast';
import { DROPDOWN_CONFIG, DATATABLE_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';

// ── Dummy data ──────────────────────────────────────────────────────────────
const DUMMY_TABLE_DATA = [
    {
        id: 1,
        item: 'Mid Day Meal',
        sellingQty: 2,
        sellingAddonQty: 0,
        sellingPrice: 309.1,
        sellingAmount: 618.2,
        purchasePrice: 60,
        purchaseAmount: 120,
        profitRatio: 80.59,
    },
    {
        id: 2,
        item: 'Ss Dine Paneer Lawabdaar',
        sellingQty: 126,
        sellingAddonQty: 0,
        sellingPrice: 178.7,
        sellingAmount: 22516.2,
        purchasePrice: 60,
        purchaseAmount: 7560,
        profitRatio: 66.42,
    },
    {
        id: 3,
        item: 'Ss Dine Aneer Handi',
        sellingQty: 85,
        sellingAddonQty: 0,
        sellingPrice: 219.48,
        sellingAmount: 18655.8,
        purchasePrice: 0,
        purchaseAmount: 0,
        profitRatio: 100,
    },
    {
        id: 4,
        item: 'Chicken Afghani',
        sellingQty: 135.53,
        sellingAddonQty: 0,
        sellingPrice: 224.53,
        sellingAmount: 30430.55,
        purchasePrice: 0,
        purchaseAmount: 0,
        profitRatio: 100,
    },
    {
        id: 5,
        item: 'Chicken 65',
        sellingQty: 160.53,
        sellingAddonQty: 0,
        sellingPrice: 259.28,
        sellingAmount: 41622.22,
        purchasePrice: 0,
        purchaseAmount: 0,
        profitRatio: 100,
    },
    {
        id: 6,
        item: 'Egg Pulav',
        sellingQty: 112,
        sellingAddonQty: 0,
        sellingPrice: 110.35,
        sellingAmount: 12359.2,
        purchasePrice: 0,
        purchaseAmount: 0,
        profitRatio: 100,
    },
    {
        id: 7,
        item: 'Today Pizza1',
        sellingQty: 20,
        sellingAddonQty: 0,
        sellingPrice: 137.13,
        sellingAmount: 2742.6,
        purchasePrice: 20,
        purchaseAmount: 40,
        profitRatio: 85.4,
    },
];

// Dummy detail data for the modal
const DUMMY_DETAIL_DATA = [
    { ingredient: 'Tomato',  qty: '100g', unit: 'g',  unitPrice: 5,  totalCost: 0.5  },
    { ingredient: 'Onion',   qty: '50g',  unit: 'g',  unitPrice: 3,  totalCost: 0.15 },
    { ingredient: 'Chicken', qty: '200g', unit: 'g',  unitPrice: 12, totalCost: 2.4  },
    { ingredient: 'Spices',  qty: '10g',  unit: 'g',  unitPrice: 20, totalCost: 0.2  },
];

class FoodCostingReport extends Component {
    state = {
        menuItem:          '',
        fromDate:          new Date('2023-09-01'),
        toDate:            new Date('2023-09-18'),
        selectedDays:      null,
        tableData:         [],
        searched:          false,
        detailVisible:     false,
        selectedItemName:  '',
    };

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
    }

    handleSearch = () => {
        const { fromDate, toDate } = this.state;
        if (!fromDate || !toDate) {
            this.growl.show({ severity: 'error', summary: 'Error', detail: 'Please select From Date and To Date' });
            return;
        }
        if (fromDate > toDate) {
            this.growl.show({ severity: 'error', summary: 'Error', detail: 'From Date cannot be after To Date' });
            return;
        }
        // Filter by menuItem text if entered
        const filtered = this.state.menuItem
            ? DUMMY_TABLE_DATA.filter(r =>
                r.item.toLowerCase().includes(this.state.menuItem.toLowerCase()))
            : DUMMY_TABLE_DATA;
        this.setState({ tableData: filtered, searched: true });
    };

    handleShowAll = () => {
        this.setState({ tableData: DUMMY_TABLE_DATA, searched: true });
    };

    handleExportExcel = () => {
        this.growl.show({ severity: 'info', summary: 'Export', detail: 'Export triggered' });
    };

    // ── Column body templates ────────────────────────────────────────────────

    profitRatioTemplate = (rowData) => {
        const color = rowData.profitRatio === 100 ? '#22c55e' : '#3b82f6';
        return (
            <span style={{
                background: color + '18',
                color,
                fontWeight: 600,
                padding: '2px 10px',
                borderRadius: '4px',
            }}>
                {rowData.profitRatio}
            </span>
        );
    };

    purchasePriceTemplate = (rowData) => {
        const color = rowData.purchasePrice === 0 ? '#22c55e' : '#3b82f6';
        return (
            <span
                style={{ color, fontWeight: 600, cursor: 'pointer', textDecoration: 'underline dotted' }}
                title="Click to view Detail"
                onClick={() => this.setState({
                    detailVisible: true,
                    selectedItemName: rowData.item,
                })}
            >
                {rowData.purchasePrice}
            </span>
        );
    };

    sellingQtyTemplate = (rowData) => (
        <span>{Number(rowData.sellingQty).toFixed(2)}</span>
    );

    render() {
        if (this.getAccess !== undefined && this.getAccess.viewAccess === false) {
            this.props.history.push('/dashboard');
        }

        const { tableData, searched, fromDate, toDate, detailVisible, selectedItemName, selectedDays } = this.state;

        const header = (
            <div style={{ textAlign: 'right' }}>
                <InputText
                    type="search"
                    onInput={(e) => this.setState({ globalFilter: e.target.value })}
                    placeholder="Search..."
                />
            </div>
        );

        // ── Detail modal footer ────────────────────────────────────────────
        const modalFooter = (
            <Button
                label="Close"
                icon="pi pi-times"
                className="p-button-secondary"
                onClick={() => this.setState({ detailVisible: false })}
            />
        );

        return (
            <div className="p-grid padding">
                {this.props.loading  && <div className="page-loader"></div>}
                {this.props.error   !== null && <Messages type="error"   message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />

                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Food Costing Report</h1>

                        {/* ── Filter Row ──────────────────────────────────── */}
                        <div className="p-grid p-align-end">

                            {/* Menu Item */}
                            <div className="p-col-12 p-md-2 p-lg-2 p-d-flex p-flex-column p-gap-2">
                                <label className="label">Menu Item</label>
                                <InputText
                                    placeholder="Menu Item"
                                    className="p-col-12"
                                    value={this.state.menuItem}
                                    onChange={(e) => this.setState({ menuItem: e.target.value })}
                                />
                            </div>

                            {/* From Date */}
                            <div className="p-col-12 p-md-2 p-lg-2 p-d-flex p-flex-column p-gap-2">
                                <label className="label">From Date</label>

                                <Calendar
                                    placeholder="From Date"
                                    value={fromDate}
                                    onChange={(e) => this.setState({ fromDate: e.value })}
                                    // className="p-col-12"
                                />
                                 {/* <div className="mt1">
                                        <Calendar
                                        placeholder={"From Date"}
                                        value={fromDate && new Date(fromDate) || ''}
                                        name={"FromDate"}
                                        onChange={this.handlechange.bind(this)} />
                                  </div>                         */}
                            </div>

                            {/* To Date */}
                            <div className="p-col-12 p-md-2 p-lg-2 p-d-flex p-flex-column p-gap-2">
                                <label className="label">To Date</label>
                                <Calendar
                                    placeholder="To Date"
                                    value={toDate}
                                    onChange={(e) => this.setState({ toDate: e.value })}
                                    // dateFormat="d M yy"
                                    // showIcon
                                    // className="p-col-12"
                                />
                            </div>

                            {/* Select Days radio */}
                            <div className="p-col-12 p-md-3 p-lg-3 p-d-flex p-flex-column p-gap-2">
                                <label className="label">Select Days</label>
                                <div className="p-d-flex p-ai-center p-gap-2" style={{ gap: '16px' }}>
                                    {[30, 45, 90].map(day => (
                                        <div key={day} className="p-d-flex p-ai-center" style={{ gap: '6px' }}>
                                            <RadioButton
                                                inputId={`day_${day}`}
                                                value={day}
                                                onChange={(e) => this.setState({ selectedDays: e.value })}
                                                checked={selectedDays === day}
                                            />
                                            <label htmlFor={`day_${day}`} style={{ cursor: 'pointer' }}>{day}</label>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Search + Show All */}
                            <div className="p-col-12 p-md-3 p-lg-3 p-d-flex p-ai-end p-gap-2">
                                <Button
                                    label="Search"
                                    className="p-button-primary"
                                    onClick={this.handleSearch}
                                />
                                <Button
                                    label="Show All"
                                    className="p-button-secondary p-ml-2"
                                    onClick={this.handleShowAll}
                                />
                            </div>

                            {/* Export — own row, far right */}
                            <div className="p-col-12 p-d-flex p-jc-end p-mt-1">
                                <Button
                                    label="Export as Excel"
                                    className="p-button-warning"
                                    onClick={this.handleExportExcel}
                                />
                            </div>

                        </div>
                        {/* ── End Filter Row ──────────────────────────────── */}

                        {/* ── DataTable ───────────────────────────────────── */}
                        {searched && (
                            <div className="p-col-12" style={{ marginTop: '1.5em' }}>
                                <DataTable
                                    value={tableData}
                                    globalFilter={this.state.globalFilter}
                                    header={header}
                                    {...DATATABLE_CONFIG}
                                >
                                    <Column
                                        field="item"
                                        header="Item"
                                        sortable
                                        style={{ minWidth: '220px' }}
                                    />
                                    <Column
                                        field="sellingQty"
                                        header="Selling Quantity"
                                        sortable
                                        body={this.sellingQtyTemplate}
                                        style={{ textAlign: 'center' }}
                                    />
                                    <Column
                                        field="sellingAddonQty"
                                        header="Selling Addon Qty"
                                        sortable
                                        style={{ textAlign: 'center' }}
                                    />
                                    <Column
                                        field="sellingPrice"
                                        header="Selling Price ₹"
                                        sortable
                                        style={{ textAlign: 'right' }}
                                    />
                                    <Column
                                        field="sellingAmount"
                                        header="Selling Amount ₹"
                                        sortable
                                        style={{ textAlign: 'right' }}
                                    />
                                    <Column
                                        field="purchasePrice"
                                        header="Purchase Price ₹"
                                        sortable
                                        body={this.purchasePriceTemplate}
                                        style={{ textAlign: 'center' }}
                                    />
                                    <Column
                                        field="purchaseAmount"
                                        header="Purchase Amount ₹"
                                        sortable
                                        style={{ textAlign: 'right' }}
                                    />
                                    <Column
                                        field="profitRatio"
                                        header="Profit Ratio (%)"
                                        sortable
                                        body={this.profitRatioTemplate}
                                        style={{ textAlign: 'center' }}
                                    />
                                </DataTable>
                            </div>
                        )}

                        {/* Empty state */}
                        {!searched && (
                            <div
                                className="p-d-flex p-jc-center p-ai-center"
                                style={{ minHeight: '200px', color: '#aaa', fontSize: '15px' }}
                            >
                                <i className="pi pi-search p-mr-2" />
                                Select filters and click Search to view the report.
                            </div>
                        )}

                    </div>
                </div>

                {/* ── Purchase Price Detail Modal ──────────────────────────── */}
                <Dialog
                    header={`Purchase Price Detail — ${selectedItemName}`}
                    visible={detailVisible}
                    style={{ width: '560px' }}
                    footer={modalFooter}
                    onHide={() => this.setState({ detailVisible: false })}
                >
                    <DataTable value={DUMMY_DETAIL_DATA}>
                        <Column field="ingredient" header="Ingredient" />
                        <Column field="qty"        header="Qty" />
                        <Column field="unit"       header="Unit" />
                        <Column field="unitPrice"  header="Unit Price (₹)" style={{ textAlign: 'right' }} />
                        <Column field="totalCost"  header="Total Cost (₹)" style={{ textAlign: 'right' }} />
                    </DataTable>
                </Dialog>

            </div>
        );
    }
}

const mapStateToProps = state => ({
    loggedUserDetail: state.auth.userObject,
    loading:          state.master.loading,
    error:            state.master.error,
    success:          state.master.success,
    tableLists:       state.master.tableLists,
});

const mapDispatchToProps = dispatch => ({
    dynamicDeleteProcess: (model, data, func) => dispatch(actions.dynamicDeleteProcess(model, data, func)),
    getMasterTableList:   (table)             => dispatch(actions.getMasterTableList(table)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FoodCostingReport);